

import { useContext } from 'react';

import { Axis, Vertex3 } from '@rta/rta-blueprint-library';

import { AppContext } from '@r-app/app-context';
import { DimensionLine } from '@r-components';
import { DisplayMode } from '@r-core';
import { ShowDimensions } from '@r-core/types';
import { usePanel } from '@r-hooks';
import {
	DIMENSION_BREAKPOINT_PADDING_HORIZONTAL,
	DIMENSION_OUTSIDE_LINE_OFFSET_Y,
	DIMENSION_OUTSIDE_PANEL_PADDING_HORIZONTAL,
	DIMENSION_OUTSIDE_PANEL_PADDING_VERTICAL
} from '@r-core/constants';

export type DrawPanelBaseDimensionsParams = {
	panelId: string;
	isCountertop?: boolean;
}

export const DrawPanelBaseDimensions = (params: DrawPanelBaseDimensionsParams): React.ReactElement => {
	const { controller } = useContext(AppContext);
	const { options, navigation } = controller;

	const { panelId, isCountertop = false } = params;
	const [{ island, panel }, panelMeta] = usePanel({ panelId, isCountertop });
	// const hasBreakPoints = isCountertop
	// 	? panelMeta.countertop.breakpoints.length > 0
	// 	: panelMeta.panel.breakpoints.length > 0;
	// const yBpLineOffset = hasBreakPoints ? 1 : 0;

	// console.log('DrawPanelDimensions', panelMeta);

	// const dimensionOptionsVertical: DimensionOptions | null = null;
	// const dimensionOptionsHorizontal: DimensionOptions | null = null;
	// const dimensionBaseOptions: DimensionOptions = {
	// 	fontSize: DIMENSION_FONT_SIZE * options.dimensions.fontSizeFactor,
	// 	useFractions: options.useFractions,
	// 	indicatorEnd: 'arrow',
	// 	indicatorStart: 'arrow',
	// 	type: DimensionType.Inside,
	// 	height: 0,
	// 	width: 0,
	// 	xOffset: 0,
	// 	yOffset: panelMeta._offsets.origin.y,
	// 	xTextFactor: 0.6,
	// 	yTextFactor: 0.3
	// };

	let { showCountertops, showAppliances } = options;
	let includeLabelBox = true;
	let maxDistanceAboveCountertop = 0;
	const hasBreakPoints = panelMeta.breakpoints.length > 0;
	const horizontalDimensionPadding = (hasBreakPoints ? DIMENSION_BREAKPOINT_PADDING_HORIZONTAL : 0) + DIMENSION_OUTSIDE_PANEL_PADDING_HORIZONTAL;
	switch (navigation.displayMode) {
		case DisplayMode.Manufacturing:
		case DisplayMode.InlineManufacturing:
			showCountertops = false;
			includeLabelBox = false;
			showAppliances = false;
			break;
		default:
			maxDistanceAboveCountertop = panel.panelItemGroups.getMaxDistanceAboveCountertop();
	}

	const overallWidth = showCountertops ? (panelMeta.connections.right.countertopOverhang - panelMeta.connections.left.countertopOverhang) / 2 : 0;

	// if (island !== null && options.showDimensionsMode !== ShowDimensions.None) {
	// 	if (isCountertop) {
	// 		dimensionBaseOptions = {
	// 			...dimensionBaseOptions,
	// 			height: panelMeta._size.outside.height - panelMeta._overhangs.front - panelMeta._overhangs.back,
	// 			width: panelMeta._size.physical.width - panelMeta._overhangs.left - panelMeta._overhangs.right,
	// 			xOffset: 0,
	// 			yOffset: panelMeta._offsets.origin.y + panelMeta._overhangs.back
	// 		};
	// 	} else {
	// 		dimensionBaseOptions = {
	// 			...dimensionBaseOptions
	// 		};
	// 	}
	// 	dimensionOptionsVertical = dimensionBaseOptions;
	// 	dimensionOptionsHorizontal = {
	// 		...dimensionBaseOptions,
	// 		yOffset: dimensionBaseOptions.yOffset - yBpLineOffset
	// 	};

	// 	return (<>
	// 		<DrawVerticalDimension dimensionOptions={dimensionOptionsVertical} controller={controller} />
	// 		<DrawHorizonalDimension dimensionOptions={dimensionOptionsHorizontal} controller={controller} />
	// 	</>);
	// }

	if (island !== null && options.showDimensionsMode !== ShowDimensions.None) {
		// const { corners, position } = panel.getCornerPoints(true);
		// const { corners } = panelMeta.panel.getSidePoints(null, showCountertops);
		const { height, width } = showCountertops ? panelMeta.size.outside : panelMeta.size.physical;
		// panelMeta._size.visible;
		return <>
			<DimensionLine
				length={height}
				persist={{ sourceId: panel.id, targetId: island.id }}
				bBox={{
					origin: new Vertex3({
						dataIn: {
							x: panel.size.width / -2,
							y: (panel.size.height / -2) + (showCountertops ? panelMeta.countertop.material.thickness / -2 : 0)
						}
					}),
					size: { width, height, depth: 0 }
				}}
				axis={new Axis({ dataIn: { x: 0, y: 0, z: 90 }})}
				includeLabelBox={includeLabelBox}
				padding={DIMENSION_OUTSIDE_PANEL_PADDING_VERTICAL}
				indicatorStart="flat" indicatorEnd="flat"
				canMove={true}
				level={true}
				dragConstraint="1d"
			/>
			{/* total width of panel */}
			<DimensionLine
				length={width}
				persist={{ sourceId: island.id, targetId: panel.id }}
				bBox={{
					origin: new Vertex3({
						dataIn: {
							y: -panel.size.height,
							x: overallWidth
						}
					}),
					size: { width, height, depth: 0 }
				}}
				axis={new Axis({ dataIn: { x: 0, y: 0, z: 0 }})}
				includeLabelBox={includeLabelBox}
				padding={(showAppliances ? -maxDistanceAboveCountertop : 0) - horizontalDimensionPadding - (showCountertops ? panelMeta.countertop.material.thickness : 0)}
				indicatorStart="flat" indicatorEnd="flat"
				canMove={true}
				dragConstraint="1d"
			/>
		</>
	}

	return <></>;
};
